import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "./context/AuthContext";
import { ProfileProvider } from "./context/ProfileContext";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Welcome from "./pages/Welcome";
import Browse from "./pages/Browse";
import MovieDetail from "./pages/MovieDetail";
import MyList from "./pages/MyList";
import Admin from "./pages/Admin";
import ProfileSelect from "./pages/ProfileSelect";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ProfileProvider>
            <Navbar />
            <Toaster theme="dark" position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/welcome"
                element={
                  <ProtectedRoute>
                    <Welcome />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profiles"
                element={
                  <ProtectedRoute>
                    <ProfileSelect />
                  </ProtectedRoute>
                }
              />
              <Route path="/browse" element={<Browse />} />
              <Route path="/movie/:id" element={<MovieDetail />} />
              <Route
                path="/my-list"
                element={
                  <ProtectedRoute>
                    <MyList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </ProfileProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
